class ReceptadatlapV2 {

    constructor() {
        this.init();
    }

    init() {
        this.moveShortVideo();
        $(window).on('resize', () => this.moveShortVideo());
    }

    moveShortVideo() {
        var $video = $('.short-video');
        if ($video.length === 0) return;
        var $left = $('.receptsides-left');
        var $right = $('.receptsides-right');
        if (window.innerWidth < 980) {
            if ($video.parent().is($right)) {
                $left.prepend($video);
            }
        } else {
            if ($video.parent().is($left)) {
                $right.prepend($video);
            }
        }
    }
}

export default ReceptadatlapV2;
